import * as yup from "yup";

export const userGroupValidation = yup.object({
  name: yup.string().required("Naziv je obavezan"),
});
